import React from "react";
import { Skeleton } from "primereact/skeleton";

const TableThSkeleton = () => {
  return (
    <th colSpan="1" className="text-center" style={{ width: "100%" }}>
      <Skeleton className="mb-2"></Skeleton>
    </th>
  );
};

export default TableThSkeleton;
